import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Flex } from '~/shared/components';
import { dateValues, dateDisplayNames } from '../constants';
import { DisplayDateTitleProps } from '../types';

const DateBoxTextWrapper = styled(Flex)`
  color: inherit;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #4c5e72;
  pointer-events: none;
  overflow: visible;
`;

const DisplayDateTitle = ({ measure }: DisplayDateTitleProps) => {
  const [dateTitle, setDateTitle] = useState('');

  useEffect(() => {
    dateValues.forEach((d: any, i: number) => {
      if (measure === d) {
        setDateTitle(dateDisplayNames[i]);
      }
    });
    if (!dateValues.includes(String(measure))) {
      setDateTitle('Date');
    }
  }, [measure]);

  return <DateBoxTextWrapper>{dateTitle}:</DateBoxTextWrapper>;
};

export default DisplayDateTitle;
